import { useMemo, useState } from "react";
import clsx from "clsx";
import { LeftArrow, RightArrow } from "../../icons";
import { useFetchLoyaltyDrupalContent } from "../../hooks/react-query/useLoyalty";
import usePersonStore from "../../store/personStore";

export const LoyaltySliderSection = () => {

  const assignedRoles = usePersonStore((store) => store.userRoles);
  const sliderImagesRole = assignedRoles?.includes("fleetadmin") ? "fleet-admin" : assignedRoles?.includes("driver") ? "driver" : "logged-in-user-without-cars"
  const {data: cmsContentCards} = useFetchLoyaltyDrupalContent({role:sliderImagesRole, params:{}});

  function decodeHtmlEntities(str) {
    if (typeof str !== 'string') {
        return ""
    }

    // Create a temporary DOM element
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  const cards = useMemo(
    () => {
      if(cmsContentCards?.length > 0){
        return cmsContentCards?.map((card) => {return {
          title: card?.field_title,
          subtitle: card?.field_subtitle,
          subtitle1: decodeHtmlEntities(card?.field_subtitle_1),
          img: `${card?.field_image}`,
          // img: `${process.env.REACT_APP_CMS_BASE_URL}${card?.field_image}`,
          link: `${process.env.REACT_APP_CMS_BASE_URL}${card?.field_link}`,
        }})
      } else {
        return []
      }
    },[cmsContentCards]);

  const CARD_W = 630; // tweak to match your design
  const GAP = 20;

  const [index, setIndex] = useState(0);
  const maxIndex = Math.max(0, cards?.length - 1);

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(maxIndex, i + 1));

  return (
    <section className="w-full">
      <div className="w-full rounded-[16px] bg-[#D4002A] p-6 text-white">
        {/* Title / Subtitle */}
        <div className='flex flex-col gap-4'>
          <h4 className="text-[20px] font-bold text-white">
            Πώς κερδίζεις χιλιόμετρα
          </h4>
          <p className="text-[18px] text-white pb-6">
            {cards?.[index]?.subtitle}
          </p>
        </div>

        {/* Slider viewport */}
        <div className="overflow-hidden pb-6">
          <div
            className="flex"
            style={{
              gap: `${GAP}px`,
              transform: `translateX(-${index * (CARD_W + GAP)}px)`,
              transition: "transform 320ms ease",
              willChange: "transform",
            }}
          >
            {cards?.map((c) => (
              <div
                key={c.title}
                className="shrink-0"
                style={{ width: CARD_W }}
              >
                {/* Card: square corners, image + white body no gap */}
                <div className="overflow-hidden rounded-lg bg-white text-black">
                  <img
                    src={c.img}
                    alt=""
                    aria-hidden="true"
                    className="h-[300px] w-full object-cover"
                  />
                  <div className="p-4 cursor-pointer" onClick={()=>{window.open(c?.link, "_blank", "noopener,noreferrer")}}>
                    <p className="text-[14px] font-bold">{c.title}</p>
                    <p className="mt-1 text-[12px] text-[#5A5A5A]">
                      {c.subtitle1}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom controls */}
        <div className="flex items-center justify-between">
          {/* Left arrows */}
          {cards?.length > 0 && <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={prev}
              disabled={index === 0}
              className={clsx(
                "h-9 w-9 rounded-full border border-white grid place-items-center pr-1",
                index === 0 ? "opacity-40 cursor-not-allowed" : "hover:bg-white/10"
              )}
              aria-label="Previous"
            >
              <LeftArrow className='w-4 h-4 stroke-white'/>
            </button>

            <button
              type="button"
              onClick={next}
              disabled={index === maxIndex}
              className={clsx(
                "h-9 w-9 rounded-full border border-white grid place-items-center pl-1",
                index === maxIndex ? "opacity-40 cursor-not-allowed" : "hover:bg-white/10"
              )}
              aria-label="Next"
            >
              <RightArrow className='w-4 h-4 stroke-white'/>
            </button>
          </div>}

          {/* Learn more (bottom-right) */}
          <div className="w-full flex flex-row justify-end">
            <button
              onClick={async ()=> {window.open(`https://myavis.gr/el/avis-more-loyalty-program#pos-kerdizo-xiliometra`, "_blank", "noopener,noreferrer");}}
              // onClick={async ()=> {window.open(`${process.env.REACT_APP_CMS_BASE_URL}/el/avis-more-loyalty-program#pos-kerdizo-xiliometra`, "_blank", "noopener,noreferrer");}}
              className="rounded-[6px] border border-white/70 bg-transparent px-6 py-2 text-sm font-semibold hover:bg-white/10"
            >
              Μάθε περισσότερα
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}


export default LoyaltySliderSection;